import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { CLIENT_SETTINGS } from 'src/constants/EndpointUrls';
import { EditActionBtn, SaveActionBtn, CancelActionBtn } from 'src/buttons';
import {
  fetchEmailNotificationSettingList,
  getEmailSettingList,
  setEmailSettingList,
  saveEmailSettingList
} from 'src/reducers/admin_email_notification_settings/admin_email_notification_settings';
import EmailNotificationSettingTable from './components/EmailNotificationSettingTable';
import PaginationContainer from './components/PaginationContainer';

import styles from './AdminEmailNotificationSetting.scss';
import { withTranslation } from 'react-i18next';

const EDIT_MODE = 'EDIT';
const SHOW_MODE = 'SHOW';

class AdminEmailNotificationSettingList extends Component {
  state = {
    mode: SHOW_MODE,
    orgEmailSettingList: []
  };

  isShowMode = () => this.state.mode === SHOW_MODE;

  componentDidMount() {
    this.props.fetchNotificationSettingList();
  }

  toEditMode = () => {
    const { emailSettingList = [] } = this.props;
    this.setState({
      ...this.state,
      mode: EDIT_MODE,
      orgEmailSettingList: _.map(emailSettingList, item => ({ ...item }))
    });
  };

  cancelEditMode = () => {
    const { dispatch } = this.props;
    dispatch(setEmailSettingList(this.state.orgEmailSettingList));
    this.setState({ ...this.state, mode: SHOW_MODE, orgEmailSettingList: [] });
  };

  closeEditMode = () => {
    this.setState({ ...this.state, mode: SHOW_MODE, orgEmailSettingList: [] });
  };

  render() {
    const { saveSettingList } = this.props;
    return (
      <div>
        <div className="l-main-title-wrap">
          <h1 className="m-title-main">{this.props.t('features.AdminEmailNotificationSetting.AdminEmailNotificationSettingList.mail_notification_setting')}</h1>
          <p className="m-title-main-note">{this.props.t('features.AdminEmailNotificationSetting.AdminEmailNotificationSettingList.You_can_configure_the_setting_for_receiving_emails_sent_to_admin')}</p>
        </div>
        <div className="l-wrap-xl l-contents-wrap">
          <div className="u-mb20">
            <BreadCrumb>
              <BreadCrumb.Item label={this.props.t('components.SideMenu.SideMenu.setting')} path={CLIENT_SETTINGS} />
              <BreadCrumb.Item label={this.props.t('features.AdminEmailNotificationSetting.AdminEmailNotificationSettingList.mail_notification_setting')} />
            </BreadCrumb>
          </div>
          <div className={styles.description}>
            <p>{this.props.t('features.AdminEmailNotificationSetting.AdminEmailNotificationSettingList.system_will_send_the_following_mails')}</p>
            <ul className={styles.items}>
              <li>・{this.props.t('features.AdminEmailNotificationSetting.AdminEmailNotificationSettingList.get_data_from_jobcan_attendance_management_and_attendance_items_CSV_upload')}</li>
              <li>・{this.props.t('features.AdminEmailNotificationSetting.AdminEmailNotificationSettingList.when_the_upload_to_create_or_update_employee_information_is_completed')}</li>
              <li>・{this.props.t('features.AdminEmailNotificationSetting.AdminEmailNotificationSettingList.when_the_salary_and_bonus_confirmation_is_completed')}</li>
              <li>・{this.props.t('features.AdminEmailNotificationSetting.AdminEmailNotificationSettingList.when_the_download_of_provision_and_deduction_data_is_completed')}</li>
            </ul>
          </div>
          <div>
            {this.isShowMode() ? (
              <div className={styles.action}>
                <EditActionBtn onClick={this.toEditMode} />
              </div>
            ) : (
              <div className={styles.action}>
                <SaveActionBtn onClick={() => saveSettingList(this.closeEditMode)} />
                <CancelActionBtn onClick={this.cancelEditMode} />
              </div>
            )}
          </div>
          <div className="u-mt20">
            <EmailNotificationSettingTable mode={this.state.mode} />
          </div>
          <PaginationContainer closeEditMode={this.closeEditMode} />
        </div>
      </div>
    );
  }
}

export default withTranslation('translation')(connect(
  state => ({
    emailSettingList: getEmailSettingList(state)
  }),
  dispatch => ({
    fetchNotificationSettingList: () => {
      dispatch(fetchEmailNotificationSettingList());
    },
    saveSettingList: closeEditMode => {
      dispatch(saveEmailSettingList(closeEditMode));
    },
    dispatch
  })
)(AdminEmailNotificationSettingList));
